import { PropsWithChildren } from 'react';
import { XIcon } from './icons';

interface Props extends PropsWithChildren {
  titulo: string;
  onClose: () => void;
}

export function Modal({ titulo, onClose, children }: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-ink/45 pt-16"
      role="dialog"
      aria-modal="true"
      data-testid="modal-backdrop"
    >
      <div className="w-full max-w-xl max-h-[85vh] overflow-y-auto bg-white rounded-2xl shadow-2xl flex flex-col">
        <div className="flex items-center justify-between px-7 py-5 border-b border-admin-border">
          <h2 className="text-xl font-display font-semibold text-wood">{titulo}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            data-testid="modal-close-button"
            className="text-admin-ink-muted hover:text-admin-ink"
          >
            <XIcon />
          </button>
        </div>
        <div className="px-7 py-6 flex flex-col gap-4">{children}</div>
      </div>
    </div>
  );
}
